import client from '../client';
import * as costMutations from "../mutations/cost";
import * as costQueries from "../queries/cost";



export function getCosts(success, error, fogId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { fogId: fogId },
        fetchPolicy: fetchPolicy,
        query: costQueries.all,
    })
        .then(success)
        .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: costQueries.get,
    })
        .then(success)
        .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { cost: data },
        mutation: costMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, cost: data },
        mutation: costMutations.edit,
    }).then(success).catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/cost.js